export default {
    props: {
        sortDir: {
            type: String,
            kComposite: 'sort.dir'
        },
        sortField: {
            type: String,
            kComposite: 'sort.field'
        },
        sortCompare: {
            type: Function,
            kComposite: 'sort.compare'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoDataSourceBase/Sort.js